import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export function getDefaultAvatar(initials: string, domSanitizer: DomSanitizer): SafeResourceUrl {
  const colors = ['#339966', '#418B76', '#31989B', '#1581A2', '#1E6091', '#184E77'];
  const colorIndex = Math.floor(Math.random() * 6);

  initials = initials
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/[\u00A0-\u2666]/g, (x) => '&#' + x.charCodeAt(0) + ';');

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 64 64" version="1.1"><rect fill="${colors[colorIndex]}" width="64" height="64" cx="32" cy="32" r="32"/><text x="50%" y="50%" style="color: #ffffff;line-height: 1;font-family: 'Roboto', 'Arial'" text-anchor="middle" font-size="26" font-weight="400" dy=".35em" fill="#ffffff">${initials}</text></svg>`;

  return domSanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${btoa(svg)}`);
}
